import React, { useMemo } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import PlantsTableComponent from "../../Project/plant/PlantsTable";
import { useAmsModuleData } from "../context/AmsModuleDataContext";

export default function PlantData() {
  const { plant, isLoading, isError } = useAmsModuleData();

  const data = useMemo(() => {
    return plant?.id ? [plant] : [];
  }, [plant]);

  return (
    <Box sx={{ p: 2 }}>
      {isError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          Error loading plant data.
        </Alert>
      ) : null}

      {isLoading && data.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 2,
          }}
        >
          <CircularProgress size={20} />
          Loading plant data...
        </Box>
      ) : null}

      <PlantsTableComponent plants={data} />
    </Box>
  );
}
